import { CountryStatesStateInterface } from '.';

function state(): CountryStatesStateInterface {
  return {
    countryStates: [],
  };
}

export default state;
